import classNames from 'classnames'
import Button from '../../button/Button'


export interface IProceedToPayment {
    className?: string
    isModalOpen: boolean
    handleClick: () => void
}

const ProceedToPayment: React.FC<IProceedToPayment> = ({ className, isModalOpen, handleClick }) => {
    return (
        <div className={classNames(className, isModalOpen ? "blur-lg" : "", "lg:w-[55rem] w-full lg:shadow-md lg:bottom-3 bottom-0 text-center")}>
            <div className="bg-[#0082ca] flex flex-col items-center shadow-md hover:bg-[#49a4d7] cursor-pointer w-full">
                <div className={"lg:grid lg:grid-cols-1 flex flex-row space-x-3 w-full justify-center"}>
                    <Button className="text-center text-black font-semibold items-center lg:h-20 h-16 w-full flex justify-center" text='confirmButton' textSize='text-2xl' handleClick={handleClick} />
                </div>
            </div>
        </div>
    )
}

export default ProceedToPayment
